"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const Flex_1 = require("../Elements/Flex");
const Texts_1 = require("../Texts");
const StyledComponents_1 = require("./StyledComponents");
const defaultProps = {
    showError: true,
};
const TextInput = ({ prependElements, appendElements, children: _, error, hint, label, showError, ...restProps }) => {
    const { margins, rest } = (0, StyledFunctions_1.extractMarginAndPadding)(restProps);
    const [flex, notFlex] = (0, Flex_1.extractFlex)(rest);
    const [elementSizes, inputProps] = (0, StyledFunctions_1.extractElementSizes)(notFlex);
    return (react_1.default.createElement(StyledComponents_1.Container, { ...margins, ...flex },
        label && react_1.default.createElement(Texts_1.LabelText, null, label),
        react_1.default.createElement(StyledComponents_1.InputContainer, { error: error ? true : false, ...elementSizes },
            prependElements,
            react_1.default.createElement(StyledComponents_1.Input, { ...inputProps }),
            appendElements),
        showError && react_1.default.createElement(Texts_1.HintText, { error: !!error },
            error || hint,
            "\u00A0")));
};
TextInput.defaultProps = defaultProps;
exports.default = react_1.default.memo(TextInput);
